import * as Api from "@api";
import { State } from "../";
import { ActionType } from "../types";
import { ThunkAction } from "redux-thunk";
import {
  InfrastructureApplication,
  InfrastructureApplicationsAction,
} from "../types/infrastructure-applications";

function getInfrastructureApplicationsRequest(
  key: string
): InfrastructureApplicationsAction {
  return {
    type: ActionType.GET_INFRASTRUCTURE_APPLICATIONS_REQUEST,
    key,
  };
}

function getInfrastructureApplicationsSuccess(
  key: string,
  infrastructureApplications: InfrastructureApplication[]
): InfrastructureApplicationsAction {
  return {
    type: ActionType.GET_INFRASTRUCTURE_APPLICATIONS_SUCCESS,
    key,
    infrastructureApplications,
  };
}

function getInfrastructureApplicationsFailure(
  key: string,
  error: any
): InfrastructureApplicationsAction {
  return {
    type: ActionType.GET_INFRASTRUCTURE_APPLICATIONS_FAILURE,
    key,
    error,
  };
}

export function getInfrastructureApplications(
  application: number
): ThunkAction<void, State, unknown, InfrastructureApplicationsAction> {
  return async (dispatch, getState) => {
    const { network } = getState();
    const key = `${application.toString()}`;

    if (!network.fetching.environments[key]) {
      dispatch(getInfrastructureApplicationsRequest(key));
      try {
        const infrastructureApplications = await Api.getInfrastructureApplications(
          application
        );

        dispatch(
          getInfrastructureApplicationsSuccess(key, infrastructureApplications)
        );
      } catch (error) {
        dispatch(getInfrastructureApplicationsFailure(key, error));
      }
    }
  };
}
